import "./styles.scss";

import App from "./App";
import initializeSvelteApp from "common/initializeSvelteApp";

initializeSvelteApp({
  component: App,
  target: ".js-stream-chat",
  props: element => {
    return {
      src: element.getAttribute("data-src"),
      enabled: element.getAttribute("data-enabled") == "true",
    };
  },
});
